import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=27b4b8da&"
import script from "./TransactionItem.vue?vue&type=script&lang=ts&"
export * from "./TransactionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports